import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import ReadyToPublishFlag from './subComponents/readyToPublishFlag';
import QuizInstructions from './subComponents/quizInstructions';
import ExtraContent from './subComponents/extraContent';
import TextInput from '../../../../components/textInput';

class QuizInfo extends Component{
  constructor(props){
    super(props);
    this.state={
      isExam: null,
      quizType: "",
      quizLevel: "",
      quizInstructions: "",
      hasExtraContent: false,
      extraContent: ""
    }
    this.onChange = this.onChange.bind(this);
    this.changeIsExam = this.changeIsExam.bind(this);
    this.changeQuizType = this.changeQuizType.bind(this);
    this.changeLevel = this.changeLevel.bind(this);
    this.changeInstructions = this.changeInstructions.bind(this);
    this.extraContentToggle = this.extraContentToggle.bind(this);
    this.changeExtraContent = this.changeExtraContent.bind(this);
  }

  onChange(field, value){
    this.setState({[field]: value});
    this.props.onChange(field, value);
  }

  changeIsExam(content){
    this.props.onChange("quizIsExam", content);
  }
  changeQuizType(content){
    this.props.onChange("quizType", content);
  }
  changeLevel(content){
    this.props.onChange("quizLevelOfKnowledge", content);
  }
  changeInstructions(content){
    this.props.onChange("quizInstructions", content);
  }
  extraContentToggle(){
    this.setState({
      hasExtraContent: !this.state.hasExtraContent
    }, function() {
      if(!this.state.hasExtraContent){
        this.setState({
          extraContent: ""
        });
      }
    });
  }
  changeExtraContent(index, content){
    this.props.onChange("quizExtraInfo", content);
    // console.log("Extra content to change", content)
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.state.quizExtraInfo){
      this.setState({
        hasExtraContent: true
      });
    }
  }


  render(){
    return(
      <div>
        <ReadyToPublishFlag
          onChange={this.onChange}
          ready={this.props.state.quizReadyToPublish}
        />
        <h4><FormattedMessage id="qp-info-title"/></h4>
        <TextInput 
          onChange={this.props.onChange} 
          labelID="qp-title-input" 
          textName="quizTitle"
          content={this.props.state.quizTitle}
          limitFromRules={this.props.state.quizRules ? this.props.state.quizRules.TitleMaxLength : null}
        />
        <QuizInstructions
          onChange={this.changeInstructions}
          content={this.props.state.quizInstructions}
          language={this.props.language}
          lessonGrade={this.props.state.lessonGrade}
          lessonSubject={this.props.state.lessonSubject}
          limitFromRules={this.props.state.quizRules ? this.props.state.quizRules.InstructionMaxLength : null}
        />
        <ExtraContent
          extraContentToggle={this.extraContentToggle}
          hasExtraContent={this.state.hasExtraContent}
          changeExtraContent={this.changeExtraContent}
          extraContent={this.props.state.quizExtraInfo ? this.props.state.quizExtraInfo : "" }
          lessonGrade={this.props.state.lessonGrade}
          lessonSubject={this.props.state.lessonSubject}
          language={this.props.language}
          limitFromRules={this.props.state.quizRules ? this.props.state.quizRules.ExtraInfoMaxLength : null}
          fileRules={this.props.fileRules}
        />
      </div>
    );
  }
}

export default QuizInfo;